'use client';
import { Box, Flex, IconButton, Stack, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { Logo } from '../ui/svgs/logo';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import nProgress from 'nprogress';
import { CustomConnectButton } from '../wallet/CustomConnectButton';
import { DepositButton } from '../wallet/DepositButton';
import { WithdrawButton } from '../wallet/WithdrawButton';
import { ColorModeButton } from '@/components/ui/color-mode';
import { LanguageIcon } from '@/components/ui/svgs/navIcons';
export function QuantNav() {
  const pathname = usePathname();
  const locale = pathname.split('/')[1];
  const navItemStyle = (paths: string[]) => {
    const isActive = paths.some((path) => pathname.includes(path));
    return {
      color: isActive ? 'text.t1' : 'text.t2',
      fontWeight: isActive ? 600 : 400,
    };
  };
  const router = useRouter();
  const toggleLocale = () => {
    const currentLocale = pathname.split('/')[1];
    const newLocale = currentLocale === 'en-US' ? 'zh-CN' : 'en-US';
    const newPath = pathname.replace(`/${currentLocale}`, `/${newLocale}`);
    router.push(newPath);
  };
  return (
    <Box bg="bg.t0" py={2} px={10}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={'40px'}>
          <Box cursor={'pointer'}>
            <Logo />
          </Box>
          <Flex gap={'24px'} align="center">
            <Link
              href={`/${locale}/hot-list`}
              onClick={() => {
                nProgress.start();
              }}
            >
              <Text
                fontSize={'16px'}
                whiteSpace={'nowrap'}
                {...navItemStyle(['/hot-list'])}
              >
                Trending
              </Text>
            </Link>
            <Link
              href={`/${locale}/ai-earn`}
              onClick={() => {
                nProgress.start();
              }}
            >
              <Text
                fontSize={'16px'}
                {...navItemStyle(['/ai-earn', '/ai-earn-detail'])}
                whiteSpace={'nowrap'}
              >
                AI Earn
              </Text>
            </Link>
            <Link
              href={`/${locale}/perpetual`}
              onClick={() => {
                nProgress.start();
              }}
            >
              <Text
                fontSize={'16px'}
                {...navItemStyle(['/perpetual'])}
                whiteSpace={'nowrap'}
              >
                Perpetual
              </Text>
            </Link>
          </Flex>
        </Flex>
        <Stack direction="row" gap={3}>
          <DepositButton />
          <WithdrawButton />
          <CustomConnectButton />
          <ColorModeButton color={'text.t2'} />
          {/*<IconButton*/}
          {/*  aria-label="Language"*/}
          {/*  variant="ghost"*/}
          {/*  size="sm"*/}
          {/*  color="text.t2"*/}
          {/*  _hover={{*/}
          {/*    bg: 'bg.t1',*/}
          {/*  }}*/}
          {/*  onClick={toggleLocale}*/}
          {/*>*/}
          {/*  <LanguageIcon />*/}
          {/*</IconButton>*/}
        </Stack>
      </Flex>
    </Box>
  );
}
